<script>
import AccessDenied from '@/views/Page/AccessDenied.vue';

export default {
  props: ['perm'],
  render(h) {
    if (!this.$permCheck(this.perm)) return h(AccessDenied);
    const content = this.$scopedSlots.default ? this.$scopedSlots.default() : this.$slots.default;
    return content && content[0];
  },
};
</script>
